import React from "react";
import { Chip } from "@mui/material";

export default function Tag({ label, tone = "default" }) {
  const map = {
    pending: {
      bgcolor: "rgba(245,158,11,0.14)",
      border: "rgba(245,158,11,0.28)",
    },
    approved: {
      bgcolor: "rgba(22,163,74,0.14)",
      border: "rgba(22,163,74,0.28)",
    },
    rejected: {
      bgcolor: "rgba(220,38,38,0.14)",
      border: "rgba(220,38,38,0.28)",
    },
    default: {
      bgcolor: "rgba(37,99,235,0.10)",
      border: "rgba(37,99,235,0.22)",
    },
  };
  const s = map[tone] || map.default;

  return (
    <Chip
      label={label}
      sx={{
        bgcolor: s.bgcolor,
        border: `1px solid ${s.border}`,
      }}
      size="small"
    />
  );
}
